import { render } from "./About.vue?vue&type=template&id=957658de&scoped=true"
import script from "./About.vue?vue&type=script&lang=jsx"
export * from "./About.vue?vue&type=script&lang=jsx"

import "./About.vue?vue&type=style&index=0&id=957658de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957658de"]])

export default __exports__